import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {appRoutes} from './routes'

const PrivateRoutes = () => {
  const DatesMetronPage = lazy(() => import('../modules/DatesMetron/DatesMetron'))
  const CompanyPage = lazy(() => import('../modules/company/Company'))
  const MaterialPage = lazy(() => import('../modules/MaterialDashboard/MaterialDashboard'))
  const ReportsPage = lazy(() => import('../modules/Reports/Reports'))
  const ChangePasswordPage = lazy(() => import('../modules/profile/ChangePassword'))
  const RealTimeMeasurements = lazy(
    () => import('../modules/RealTimeMeasurements/RealTimeMeasurements')
  )

  const Analysis = lazy(() => import('../modules/AnalysisScreens/Analysis'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path={`${appRoutes.auth}/*`} element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path={appRoutes.dashboard} element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path={`${appRoutes.datesMetron}/*`}
          element={
            <SuspensedView>
              <DatesMetronPage />
            </SuspensedView>
          }
        />
        <Route
          path={`${appRoutes.company}/*`}
          element={
            <SuspensedView>
              <CompanyPage />
            </SuspensedView>
          }
        />
        <Route
          path={`${appRoutes.materialDashboard}/*`}
          element={
            <SuspensedView>
              <MaterialPage />
            </SuspensedView>
          }
        />
        <Route
          path={`${appRoutes.reports}/*`}
          element={
            <SuspensedView>
              <ReportsPage />
            </SuspensedView>
          }
        />

        <Route
          path={`${appRoutes.company}/*`}
          element={
            <SuspensedView>
              <CompanyPage />
            </SuspensedView>
          }
        />

        <Route
          path={`${appRoutes.changePassword}/*`}
          element={
            <SuspensedView>
              <ChangePasswordPage />
            </SuspensedView>
          }
        />
        <Route
          path={`${appRoutes.realTimeMeasurements}/*`}
          element={
            <SuspensedView>
              <RealTimeMeasurements />
            </SuspensedView>
          }
        />
        <Route
          path={`${appRoutes.analysis}/*`}
          element={
            <SuspensedView>
              <Analysis />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
